/* nb-c-ask-launcher.js
   Floating Ask launcher on every page. Product pages: visible once the buy box has scrolled above
   the viewport. Other pages: after 300px of scroll, or straight away on a short page whose content
   ends on the first screen (an empty cart). Shimmer on first show, then every ~20s while
   idle (no scroll/click for the interval). Hidden while the slide-out is open (CSS, body.nb-ask-open).
*/
(function () {
  var BUY = '[data-nb-cmax-buy], [data-nb-acc-buy], form[action*="/cart/add"]';
  function init(el) {
    if (el.__nbL) return; el.__nbL = true;
    var isProduct = el.hasAttribute('data-nb-ask-launcher-product');
    function findBuy() {
      if (!isProduct) return null;
      var c = document.querySelectorAll(BUY);
      for (var i = 0; i < c.length; i++) { if (c[i].getBoundingClientRect().height > 0) return c[i]; }
      return null;
    }
    var buy = findBuy();
    var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var visible = false, lastAct = Date.now();
    el.removeAttribute('hidden');
    function shimmer() {
      if (reduced || !visible || document.body.classList.contains('nb-ask-open')) return;
      var s = document.createElement('span');
      s.className = 'nb-c-ask-launcher__shimmer'; s.setAttribute('aria-hidden', 'true');
      el.appendChild(s); setTimeout(function () { s.remove(); }, 1300);
    }
    function want() {
      if (isProduct && (!buy || !buy.isConnected || !buy.getBoundingClientRect().height)) buy = findBuy();
      if (buy) { var r = buy.getBoundingClientRect(); return r.bottom < 0; }
      var de = document.documentElement;
      if (de.scrollHeight - innerHeight <= 300) return true;   // too short to ever reach the trigger
      var main = document.querySelector('main');
      if (main && main.getBoundingClientRect().bottom + (window.pageYOffset || de.scrollTop) <= innerHeight) return true;   // the content ends on the first screen, only the footer follows
      return (window.pageYOffset || de.scrollTop) > 300;
    }
    /* Never on top of a bar or a drawer. Probe the spot the launcher would sit in with nothing in the way: any fixed or
       sticky element at those points that is a bar (sticky add to cart, preorder bar, cookie bar, any bottom bar) lifts the
       launcher above it; anything that fills the screen (cart drawer, quick buy, a sheet) hides it until it closes. */
    var covered = false;
    function size() { return { w: el.offsetWidth || (innerWidth >= 768 ? 232 : 64), h: el.offsetHeight || 64 }; }
    // fixed or sticky elements under the launcher's spot, once it has been lifted by `up` pixels
    function blockersAt(up, d, base, right) {
      var l = innerWidth - right - d.w, t = innerHeight - base - up - d.h;
      var seen = [], top = null, cover = false;
      [0.06, 0.5, 0.94].forEach(function (fx) {
        [0.1, 0.9].forEach(function (fy) {
          document.elementsFromPoint(l + d.w * fx, t + d.h * fy).forEach(function (n) {
            if (el.contains(n) || n.closest('.nb-ask')) return;
            for (var a = n, i = 0; a && a !== document.body && a !== document.documentElement && i < 14; a = a.parentElement, i++) {
              var cs = getComputedStyle(a);
              var fixed = cs.position === 'fixed';
              // sticky counts only when it is pinned to the bottom of the screen (a bar), never a pinned stage that scrolls with the page
              if (!fixed && !(cs.position === 'sticky' && cs.bottom !== 'auto')) continue;
              if (seen.indexOf(a) < 0) {
                seen.push(a);
                var r = a.getBoundingClientRect();
                if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight && parseFloat(cs.opacity) > 0.01 && cs.visibility !== 'hidden') {
                  if (fixed && r.height > innerHeight * 0.5) cover = true;               // a drawer, a sheet, a quick buy
                  else if (r.bottom > innerHeight * 0.5) top = top === null ? r.top : Math.min(top, r.top);
                }
              }
              break;
            }
          });
        });
      });
      return { top: top, cover: cover };
    }
    function lift() {
      var base = innerWidth >= 900 ? 32 : 16;
      var right = innerWidth >= 768 ? 32 : 16;
      var d = size(), up = 0, cover = false;
      // lift above what is in the way, then look again from the new spot: a bar can sit under another fixed button
      for (var i = 0; i < 5; i++) {
        var r = blockersAt(up, d, base, right);
        if (r.cover) { cover = true; break; }
        if (r.top === null) break;
        var need = Math.round(innerHeight - r.top + 12 - base);
        if (need <= up) break;
        up = need;
      }
      if (cover !== covered) { covered = cover; el.classList.toggle('is-covered', cover); }
      el.style.bottom = (base + up) + 'px';
    }

    function update() {
      lift();
      var w = want();
      if (w === visible) return;
      visible = w;
      el.classList.toggle('is-visible', w);
      if (w) { lift(); setTimeout(shimmer, 150); }
    }
    ['scroll', 'resize'].forEach(function (t) { window.addEventListener(t, function () { lastAct = Date.now(); update(); }, { passive: true }); });
    ['click', 'keydown', 'touchstart'].forEach(function (t) { document.addEventListener(t, function () { lastAct = Date.now(); }, true); });
    setInterval(function () { if (visible && Date.now() - lastAct >= 20000) { lastAct = Date.now(); shimmer(); } }, 5000);
    setInterval(update, 200);   // also catches a page that grows or shrinks without a scroll (cart emptied)
    if (window.MutationObserver) new MutationObserver(function (rec) {
      if (rec.every(function (r) { return el.contains(r.target) || (r.target.closest && r.target.closest('.nb-ask')); })) return;
      clearTimeout(el.__nbLift); el.__nbLift = setTimeout(lift, 60);
    }).observe(document.body, { attributes: true, attributeFilter: ['class', 'hidden', 'open', 'aria-hidden', 'aria-expanded'], subtree: true, childList: true });
    update();
  }
  function all() { document.querySelectorAll('[data-nb-ask-launcher]').forEach(init); }
  document.addEventListener('DOMContentLoaded', all);
  if (document.readyState !== 'loading') all();
})();
